import axios from "axios";
import routes from "./routes";
import {buildAuthHeaders} from "@/composables/useRequestHeaders";
import {redirectOnExpiredAuth} from "@/composables/useAuthExpiry";


const error_invalid_token = 'invalid_token';
const error_profile_partially_completed = 'profile_partially_completed';
const error_member_not_active = 'member_not_active';
const error_onboarding_not_completed = 'onboarding_in_progress';

// The page is navigating away; never settle so callers cannot observe the
// rejection of a request whose failure is already fully handled.
const halt = () => new Promise(() => {});

const config = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    interceptors: {
        response: [
            response => response,
            error => {
                if (error.response === undefined) {
                    return Promise.reject(error);
                }

                if (error.response.status === 401 || error.response.data.reason === error_invalid_token) {
                    if (error.config.responseType === 'blob') {
                        return Promise.reject(error);
                    }

                    redirectOnExpiredAuth();
                    return halt();
                }

                if (error.response.data.reason === error_profile_partially_completed) {
                    window.location.pathname = '/complete-profile-reminder';
                    return halt();
                }

                if (error.response.data.reason === error_onboarding_not_completed) {
                    window.location.pathname = '/onboarding-reminder';
                    return halt();
                }

                if (error.response.data.reason === error_member_not_active) {
                    window.location.pathname = '/access-denied';
                    return halt();
                }

                // Only flatten the Laravel validation shape {errors: {field: [msg]}};
                // list-shaped errors (e.g. reconciliation parse errors) pass through.
                if (error.response.data.errors && !Array.isArray(error.response.data.errors)) {
                    for (const field in error.response.data.errors) {
                        error.response.data.errors[field] = error.response.data.errors[field][0];
                    }
                }

                return Promise.reject(error);
            }
        ],
        request: [
            config => {
                Object.assign(config.headers, buildAuthHeaders());

                // let axios set the content-type automatically for FormData
                if (config.data instanceof FormData) {
                    delete config.headers['Content-Type'];
                }

                return config;
            },
        ]
    },
}

const coordinator = axios.create({
    baseURL: window.appConfig.COORDINATOR_API_URL,
    ...config
});

const api = axios.create({
    baseURL: window.appConfig.ORG_API_URL,
    ...config
});

api.interceptors.response.use(...config.interceptors.response);
coordinator.interceptors.response.use(...config.interceptors.response);
api.interceptors.request.use(...config.interceptors.request);
coordinator.interceptors.request.use(...config.interceptors.request);

export {coordinator, api, routes};
